import { createStructuredSelector } from 'reselect';


export const NAME = 'inboxNew';

const initialLoadHasExecuted = (state) =>
  state[NAME].get('initialLoadHasExecuted');

const activeTab = (state) =>
  state[NAME].get('activeTab');


const previews = (state) =>
  state[NAME].get('previews');

const previewsLoadingState = (state) =>
  state[NAME].get('previewsLoadingState');


const contactsLoadingState = (state) =>
  state[NAME].get('contactsLoadingState');

const groupedContacts = (state) =>
  state[NAME].get('groupedContacts');


const activeConversationLoadingState = (state) =>
  state[NAME].get('activeConversationLoadingState');

const activeConversationPreloadDetails = (state) =>
  state[NAME].get('activeConversationPreloadDetails');

const activeConversationCanLoadMore = (state) =>
  state[NAME].getIn(['activeConversation', 'canLoadMore']);

const activeConversationLoadingMoreState = (state) =>
  state[NAME].get('activeConversationLoadingMoreState');

const activeConversationThreadId = (state) =>
  state[NAME].getIn(['activeConversation', 'threadId']);

const activeConversationMessages = (state) =>
  state[NAME].getIn(['activeConversation', 'messages']);

const activeConversationReceiver = (state) =>
  state[NAME].getIn(['activeConversation', 'receiver']);

const activeConversationIsMassAdminThread = (state) =>
  state[NAME].getIn(['activeConversation', 'isMassAdminThread']);

const createConversationLoadingState = (state) =>
  state[NAME].get('createConversationLoadingState');

const deleteConversationLoadingState = (state) =>
  state[NAME].get('deleteConversationLoadingState');


const uploads = (state) =>
  state[NAME].get('uploads');


const markAsSpamLoadingState = (state) =>
  state[NAME].get('markAsSpamLoadingState');


const deleteMessageLoadingState = (state) =>
  state[NAME].get('deleteMessageLoadingState');


const reportAbuseErrorMessage = (state) =>
  state[NAME].get('reportAbuseErrorMessage');

const reportAbuseLoadingState = (state) =>
  state[NAME].get('reportAbuseLoadingState');


const banUserLoadingState = (state) =>
  state[NAME].get('banUserLoadingState');


const groupConversationLoadingState = (state) =>
  state[NAME].get('groupConversationLoadingState');

const groupConversationCanLoadMore = (state) =>
  state[NAME].getIn(['groupConversation', 'canLoadMore']);

const groupConversationLoadingMoreState = (state) =>
  state[NAME].get('groupConversationLoadingMoreState');

const groupConversationThreadId = (state) =>
  state[NAME].getIn(['groupConversation', 'threadId']);

const groupConversationMessages = (state) =>
  state[NAME].getIn(['groupConversation', 'messages']);


export const selector = createStructuredSelector({
  initialLoadHasExecuted,
  activeTab,

  previews,
  previewsLoadingState,

  contactsLoadingState,
  groupedContacts,

  activeConversationLoadingState,
  activeConversationPreloadDetails,
  activeConversationCanLoadMore,
  activeConversationLoadingMoreState,
  activeConversationReceiver,
  activeConversationThreadId,
  activeConversationMessages,
  activeConversationIsMassAdminThread,

  uploads,

  createConversationLoadingState,
  deleteConversationLoadingState,

  reportAbuseLoadingState,
  reportAbuseErrorMessage,

  markAsSpamLoadingState,

  deleteMessageLoadingState,

  banUserLoadingState,

  groupConversationLoadingState,
  groupConversationCanLoadMore,
  groupConversationLoadingMoreState,
  groupConversationThreadId,
  groupConversationMessages,
});
